import script from "./PgmSignup.vue?vue&type=script&setup=true&lang=ts"
export * from "./PgmSignup.vue?vue&type=script&setup=true&lang=ts"

import "./PgmSignup.vue?vue&type=style&index=0&id=bab4a980&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bab4a980"]])

export default __exports__